<template>
  <div class="complex-wrap">
    <template v-for="child in childrenUIs">
      <div
        :class="[child.type === 'MULTICOMPLEX' ? 'complex-item_multi' : 'complex-item', isLongItem(child) ? 'long-item' : '']"
        :key="child.name"
      >
        <el-form-item :prop="child.name" :label="child.label" :rules="child.rules">
          <component :is="child.component.component" :ref="child.name" :emitUpdate="alibabaFormVm.emitUpdate" :value="catPropForm[child.name]" :props="child.component.props" :tipRule="child.tipRule" @change="changeHandle"></component>
        </el-form-item>
      </div>
    </template>
    <span v-if="childrenUIs.length" class="update-brand"
      >找不到商品属性？
      <el-link :underline="false" @click="handleUpdate">刷新数据</el-link>
    </span>
  </div>
</template>

<script>

export default {
  props: ['props'],
  inject: ['alibabaFormVm'],
  computed: {
    key() {
      return this.props.name;
    },
    catPropForm() {
      return this.alibabaFormVm.catPropForm || {};
    },
    childrenUIs() {
      let uis = [];
      let multiComplex = [];
      this.props.dataSource.children.forEach(element => {
        if (element.type === 'MULTICOMPLEX') {
          multiComplex.push(element);
        } else {
          uis.push(element);
        }
      });
      return [...uis, ...multiComplex];
    },
  },
  methods: {
    handleUpdate() {
      this.alibabaFormVm.getUiData();
    },
    isLongItem(item) {
      if(item.properties && item.properties[0]?.type === 'taoSirProperty' && item.properties[0]?.formats?.length > 4) {
        return true
      }
      if(item._oriRules?.valueTypeRule === 'multi_enum') {
        return true
      }
      return false
    },
    changeHandle(valueObj) {
      this.alibabaFormVm.catPropForm = {...this.catPropForm, ...valueObj}
    }
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.complex-wrap {
  background: #f9f9fa;
  padding: 10px 20px 20px 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  min-height: 100px;
  align-items: flex-start;
  position: relative;
  .complex-item {
    width: 245px !important;
    margin-bottom: 22px !important;
  }
  .long-item {
    width: 490px !important;
  }
  .complex-item_multi {
    width: 100% !important;
    margin-bottom: 22px !important;
  }

  ::v-deep .el-form-item {
    padding-top: 20px;
    position: relative;
    padding-right: 10px;
  }
  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
  ::v-deep .el-form-item__label {
    padding: 0;
    position: absolute;
    top: 0;
    width: 245px !important;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .update-brand {
    position: absolute;
    left: 20px;
    bottom: 0;
    font-size: 12px;
  }
}
</style>